import { useContext, useMemo } from "react";

import { formatInTimeZone } from "date-fns-tz";

import { TimeZoneContext } from "src/core/timeZoneProvider";
import {
  FORMAT,
  FORMATS,
  getSpecificDateFormat
} from "src/dataTypes/dateFormats";
import { Constants } from "src/utils/constants";
import { getUTCTimeZoneAbbreviation } from "src/utils/timeZone/timeZoneUtils";

interface FormattedDateDisplayProps {
  readonly value?: Date | -1;
  readonly format?: FORMATS;
  readonly className?: string;
  readonly showTimeZone?: boolean;
}

export const FormattedDateDisplay = ({
  value = -1,
  format = FORMAT.LONG,
  className,
  showTimeZone = true
}: FormattedDateDisplayProps) => {
  const { timeZone, hourFormat } = useContext(TimeZoneContext);
  const formattedValue = useMemo(() => {
    if (value && value !== -1) {
      const updatedFormatType = getSpecificDateFormat(format, hourFormat);
      return formatInTimeZone(value, timeZone, updatedFormatType);
    }
    return Constants.EMPTY_VALUE;
  }, [timeZone, hourFormat, value, format]);
  const hasValue = value && value !== -1;
  return (
    <span className={className} data-qa="formatted-date-display">
      {formattedValue}{" "}
      {getUTCTimeZoneAbbreviation(timeZone, {
        enabled: showTimeZone,
        hasValue
      })}
    </span>
  );
};
